var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomExpandLess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 30.2q-.7-.7-.725-1.65-.025-.95.675-1.65l9.9-9.9q.35-.35.775-.525.425-.175.875-.175t.875.175q.425.175.775.525l9.9 9.85q.7.7.7 1.675 0 .975-.7 1.625-.7.7-1.675.7-.975 0-1.675-.7L24 22l-8.2 8.25q-.65.7-1.625.675Q13.2 30.9 12.5 30.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomExpandLess);
export default __webpack_public_path__ + "static/media/custom-expand-less.10d36893fcc81c32db88856c18c818b5.svg";
export { ForwardRef as ReactComponent };